function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirefighterMiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.172,
    height: 15.96,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon material-location-on",
    d: "M13.086 3A5.582 5.582 0 0 0 7.5 8.586c0 4.189 5.586 10.374 5.586 10.374s5.586-6.184 5.586-10.374A5.582 5.582 0 0 0 13.086 3zm0 7.581a1.995 1.995 0 1 1 1.995-1.995 2 2 0 0 1-1.995 1.995z",
    transform: "translate(-7.5 -3)",
    style: {
      fill: "#707070"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefighterMiles);
export default __webpack_public_path__ + "static/media/firefighterMiles.a03ae883a00a0bd521ef412ab7581eb5.svg";
export { ForwardRef as ReactComponent };